import { useLocation } from 'react-router-dom';
import AllTravlSurveysTable from './AllTravlSurveysTable';
import ModeTravlSurveys from './ModeTravlSurveys';


export default function TravlSurveyTable() {
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const landUse = params.get('landUse') || '';
    const direction = params.get('direction') || 'Arrivals';
    const extractMode = params.get('mode') || 'counts';

    console.log(landUse);

    return (
        <>
            {extractMode === "All Modes" &&
                <AllTravlSurveysTable direction={direction} />
            }

            {extractMode !== "All Modes" && 
                <ModeTravlSurveys direction={direction} mode={extractMode} />
            }
        </>
    );
}
    